import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { makeSidLabelsFromKeys, optionsMaker } from "src/common/optionsMaker";
import { MdmDrawer } from "src/components/MdmDrawer";
import { MdmTable } from "src/components/MdmTable";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { ZRole, ZSidLabel } from "src/types";

import { makeRolesColumns } from "../makeRolesColumns";

type PropsSelectRoleModal = {
  tableStore?: RtStore<ZRole, {}>;
  srcSelected: ZSidLabel[];
  close: () => void;
  onApply: (values: ZSidLabel[]) => void;
};

export const SelectRoleModal: React.FC<PropsSelectRoleModal> = observer(
  (props) => {
    const { close, tableStore, srcSelected, onApply } = props;
    const columns = React.useMemo(() => makeRolesColumns(), []);
    const makeOption = React.useMemo(
      () => optionsMaker<ZRole>(srcSelected, ({ name }) => name),
      [srcSelected],
    );

    if (!tableStore) return null;
    const multiple = tableStore.selectionType === "checkbox";
    return (
      <MdmDrawer
        title={multiple ? "Выбор ролей" : "Выбор роли"}
        open={!!tableStore}
        onClose={close}
        wide
        extra={
          <Button
            type="primary"
            disabled={tableStore.selectedKeys.length === 0}
            onClick={() => {
              onApply(
                makeSidLabelsFromKeys(tableStore.selectedKeys, makeOption),
              );
              close();
            }}
          >
            Выбрать
          </Button>
        }
      >
        <ToolBox2
          mainTool={<RtSelection store={tableStore} makeOption={makeOption} />}
        >
          <MdmTable store={tableStore} columns={columns} />
        </ToolBox2>
      </MdmDrawer>
    );
  },
);
